exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".the-sorts-skeleton[data-v-97888c4e]{background-color:#f8f9fa;border-radius:2px;height:100%;width:100%}", ""]);

